export default "__VITE_ASSET__39c79f5a__"